/* ORANGE SHARED RUNTIME V1 (20261015)
   Single runtime shared by the Orange product template and the Orange landing template.
   Loaded from layout/theme.liquid on template suffix "orange" / "orange-offer".
   1) Benefit anchor prices: USD cents ([data-orange-usd-cents]) -> market currency via Shopify.currency.rate
   2) Offer countdown: every [data-orange-countdown="<product id>"] shares one 15-minute deadline per product
   3) Direct checkout: OrangeShared.checkout(variantId, quantity) adds the item through the Cart AJAX API
      (so Shopify / Meta / TikTok / Google receive the standard add-to-cart event), then opens checkout.
      Falls back to a cart permalink if the AJAX request fails or is slow. */
(function(){
  'use strict';
  if(window.OrangeShared) return;

  function routeRoot(){
    var root=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root?window.Shopify.routes.root:'/';
    return root.endsWith('/')?root:root+'/';
  }

  /* ---------- 1. USD benefit anchors -> market currency ---------- */
  function fractionDigits(iso){
    try{return new Intl.NumberFormat('en-US',{style:'currency',currency:iso}).resolvedOptions().maximumFractionDigits;}
    catch(e){return 2;}
  }
  function convertAnchors(root){
    if(!root||!root.querySelectorAll) return;
    var c=(window.Shopify&&window.Shopify.currency)||{};
    var iso=String(c.active||''),rate=parseFloat(c.rate);
    var nodes=[].slice.call(root.querySelectorAll('[data-orange-usd-cents]:not([data-orange-usd-done])'));
    if(root.matches&&root.matches('[data-orange-usd-cents]:not([data-orange-usd-done])')) nodes.push(root);
    nodes.forEach(function(el){
      var cents=parseFloat(el.getAttribute('data-orange-usd-cents'));
      if(isFinite(cents)&&iso&&isFinite(rate)&&rate>0){
        var digits=fractionDigits(iso);
        el.textContent=(cents/100*rate).toLocaleString('en-US',{minimumFractionDigits:digits,maximumFractionDigits:digits})+' '+iso;
      }
      el.setAttribute('data-orange-usd-done','');
      el.style.removeProperty('visibility');
    });
  }

  /* ---------- 2. Offer countdown (shared deadline per product) ---------- */
  var COUNTDOWN_MINUTES=15;
  var countdownTimer=0;
  function deadlineFor(key){
    var storageKey='orange-offer-deadline-'+String(key||'product').replace(/[^a-zA-Z0-9_-]/g,'-');
    var deadline=0;
    try{deadline=Number(window.localStorage.getItem(storageKey));}catch(e){}
    if(!deadline||deadline<=Date.now()){
      deadline=Date.now()+COUNTDOWN_MINUTES*60*1000;
      try{window.localStorage.setItem(storageKey,String(deadline));}catch(e){}
    }
    return deadline;
  }
  function renderCountdowns(){
    var nodes=document.querySelectorAll('[data-orange-countdown]');
    if(!nodes.length) return false;
    var cache={},running=false;
    nodes.forEach(function(el){
      var key=el.getAttribute('data-orange-countdown');
      if(!(key in cache)) cache[key]=deadlineFor(key);
      var remaining=Math.max(0,cache[key]-Date.now());
      if(remaining>0) running=true;
      var total=Math.floor(remaining/1000);
      el.textContent=String(Math.floor(total/60)).padStart(2,'0')+':'+String(total%60).padStart(2,'0');
    });
    return running;
  }
  function startCountdowns(){
    if(countdownTimer) return;
    if(!renderCountdowns()) return;
    countdownTimer=window.setInterval(function(){
      if(!renderCountdowns()){window.clearInterval(countdownTimer);countdownTimer=0;}
    },1000);
  }

  /* ---------- 3. Direct checkout with a real add-to-cart ---------- */
  function checkoutPermalink(variantId,quantity){
    return routeRoot()+'cart/'+encodeURIComponent(String(variantId))+':'+encodeURIComponent(String(quantity));
  }
  function checkout(variantId,quantity){
    var id=Number(String(variantId).split('/').pop());
    var qty=Math.max(1,parseInt(quantity,10)||1);
    if(!id) return Promise.reject(new Error('invalid variant'));
    var permalink=checkoutPermalink(id,qty);
    if(!window.fetch){window.location.assign(permalink);return Promise.resolve();}
    var done=false;
    var fallback=window.setTimeout(function(){if(!done){done=true;window.location.assign(permalink);}},5000);
    var headers={'Content-Type':'application/json','Accept':'application/json'};
    return fetch(routeRoot()+'cart/clear.js',{method:'POST',headers:headers,credentials:'same-origin'})
      .then(function(){
        return fetch(routeRoot()+'cart/add.js',{method:'POST',headers:headers,credentials:'same-origin',body:JSON.stringify({items:[{id:id,quantity:qty}]})});
      })
      .then(function(response){if(!response.ok) throw new Error('add failed');})
      .then(function(){if(!done){done=true;window.clearTimeout(fallback);window.location.assign(routeRoot()+'checkout');}})
      .catch(function(){if(!done){done=true;window.clearTimeout(fallback);window.location.assign(permalink);}});
  }

  window.OrangeShared={checkout:checkout,checkoutPermalink:checkoutPermalink,convertAnchors:convertAnchors,startCountdowns:startCountdowns};

  /* ---------- boot ---------- */
  function run(){convertAnchors(document);startCountdowns();}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run,{once:true});
  else run();
  if('MutationObserver' in window){
    new MutationObserver(function(records){
      for(var i=0;i<records.length;i++){
        var added=records[i].addedNodes;
        for(var j=0;j<added.length;j++){if(added[j].nodeType===1) convertAnchors(added[j]);}
      }
    }).observe(document.documentElement,{childList:true,subtree:true});
  }
  document.addEventListener('shopify:section:load',run);
})();
